<template>
  <div>
    <v-btn icon small @click="openSettingsDialog" style="margin: 0">
      <font-awesome-icon icon="gear" style="color:white;"/>
    </v-btn>
    <v-dialog v-model="dialog" width="820" height="640">
      <v-card style="width:100%;height:640px;">
        <v-card-title primary class="title" style="height:10%;">Maintenance Tasks Settings</v-card-title>
        <v-card-media style="min-height:80%; max-height:80%;">
          <v-flex v-if="display_table && !display_delete_form" d-flex md12 style="padding: 16px;">
            <dx-data-grid
                class="grid"
                :data-source="schedule"
                :show-column-lines="true"
                :show-row-lines="true"
                :show-borders="true"
                :word-wrap-enabled="true"
                :row-alternation-enabled="false"
                :column-auto-width="true"
                @selection-changed="scheduleSelected"
            >
              <DxSelection mode="single"/>
              <DxLoadPanel :enabled="false"/>
              <DxPaging :page-size="10"/>
              <dx-column data-field="vessel_name" caption="Vessel"/>
              <dx-column data-field="imo" caption="IMO"/>
              <dx-column data-field="component_name" caption="Component" sort-order="asc"/>
              <dx-column data-field="action" caption="Action"/>
              <dx-column data-field="threshold" caption="Threshold"/>
              <DxSorting mode="multiple"/>
            </dx-data-grid>
          </v-flex>
          <v-flex v-if="!display_table && display_delete_form" d-flex md12 style="padding: 16px;">
            <p class="text-justify">
              Do you want to delete <b>{{ selectedScheduleRow['vessel_name'] }}`s</b> scheduled notification for
              <b>{{ selectedScheduleRow['action'] + ' ' + selectedScheduleRow['component_name'] }}</b> at <b>{{ selectedScheduleRow['threshold'] }}</b> hours.
            </p>
          </v-flex>
          <v-flex v-if="!display_table && !display_delete_form" d-flex md12 style="padding: 16px;">
            <v-layout column>
              <v-layout row>
                <v-flex d-flex md12>
                  <v-autocomplete flat v-model="vessel" label="Vessel" :items="vessels"/>
                </v-flex>
              </v-layout>
              <v-layout row v-if="configurations.length">
                <v-flex d-flex md12>
                  <v-autocomplete flat v-model="action" label="Action" :items="actions"/>
                </v-flex>
              </v-layout>
              <v-layout row v-if="action != null">
<!--                <v-flex d-flex md12 v-if="component == null">-->
                <v-flex d-flex md12>
                  <v-autocomplete flat v-model="component" label="Components" :items="components"/>
                </v-flex>
              </v-layout>
              <v-layout row v-if="component != null">
                <!--                  <v-flex d-flex md6 style="padding-right: 8px">-->
                <!--                    <v-autocomplete flat v-model="component" label="Components" :items="components"/>-->
                <!--                  </v-flex>-->
                <!--                  <v-flex d-flex md6 style="padding-left: 8px">-->
                <!--                    <v-autocomplete flat v-model="component_index" label="Component Index" :items="component_indexes"/>-->
                <!--                  </v-flex>-->
                  <v-flex d-flex md12>
                    <v-text-field label="Threshold" hide-details="auto" v-model="threshold"/>
                  </v-flex>
              </v-layout>
<!--              <v-layout row v-if="component_index !== null">-->
<!--                <v-flex d-flex md12>-->
<!--                  <v-text-field label="Threshold" hide-details="auto" v-model="threshold"/>-->
<!--                </v-flex>-->
<!--              </v-layout>-->
            </v-layout>
          </v-flex>
        </v-card-media>
        <v-card-actions style="height:10%;">
          <v-flex v-if="display_table" d-flex md12 style="padding: 0 16px;">
            <v-flex d-flex md3>
              <v-btn @click="openNewScheduleForm" style="color:white; background-color: rgb(51,82,128);">Add to schedule</v-btn>
            </v-flex>
          </v-flex>
          <v-flex v-if="!display_table && !display_delete_form" d-flex md12 style="padding: 0 16px; justify-content: end;">
            <v-flex d-flex md2>
              <v-btn @click="closeNewScheduleForm">Cancel</v-btn>
            </v-flex>
            <v-flex d-flex md2>
              <v-btn @click="setNewSchedule" style="color:white; background-color: rgb(51,82,128);">Save</v-btn>
            </v-flex>
          </v-flex>
          <v-flex v-if="!display_table && display_delete_form" d-flex md12 style="padding: 0 16px; justify-content: end;">
            <v-flex d-flex md2>
              <v-btn @click="closeDeleteForm">Cancel</v-btn>
            </v-flex>
            <v-flex d-flex md2>
              <v-btn @click="deleteSchedule" style="color:white; background-color: rgb(51,82,128);">Delete</v-btn>
            </v-flex>
          </v-flex>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-layout v-if="loading" row style="pointer-events: none; height:100%; width:100%; position: absolute; top: 0; left: 0; z-index: 2000; justify-content: center">
      <v-flex d-flex md1 style="align-items: center;">
        <v-card>
          <v-card-media>
            <v-layout row style="height:100%; width:100%; justify-content: center; padding: 8px !important; margin: 0 !important;">
              <v-progress-circular
                  :size="200"
                  :width="10"
                  indeterminate
                  color="primary"
              />
            </v-layout>
          </v-card-media>
          <v-card-title>
            <v-layout row style="justify-content: center; color: rgb(25, 118, 210); font-weight: bold">
              Loading...
            </v-layout>
          </v-card-title>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import {DxColumn, DxDataGrid, DxFilterRow, DxHeaderFilter, DxLoadPanel, DxMasterDetail, DxPaging, DxSelection, DxSorting} from "devextreme-vue/data-grid";
import OverheadLoader from "@/components/OverheadLoader";
import axios from "axios";
import {store} from "@/main";

export default {
  name: "SettingsButton.vue",
  components: {
    DxColumn,
    DxDataGrid,
    DxFilterRow,
    DxHeaderFilter,
    DxLoadPanel,
    DxMasterDetail,
    DxPaging,
    DxSelection,
    DxSorting,
    OverheadLoader
  },
  props: {
    vessels: Array
  },
  data() {
    return {
      dialog: false,
      schedule: [],
      selectedEntries: [],
      vessel: null,
      actions: [],
      action: null,
      components: [],
      component: null,
      component_indexes: [],
      component_index: null,
      configurations: [],
      threshold: null,
      display_table: true,
      display_delete_form: false,
      loading: false,
      selectedScheduleRow: null
    }
  },
  mounted() {
    this.vessel = null
    this.action = null
    this.component = null
    this.threshold = null
    this.configurations = []
    store.loading = true
  },
  methods: {
    openSettingsDialog() {
      this.dialog = true;
      this.getTasksSchedule()
    },
    openNewScheduleForm() {
      this.display_table = false;
      this.display_delete_form = false;
    },
    closeNewScheduleForm() {
      this.display_table = true;
      this.display_delete_form = false;
      this.vessel = null;
      this.actions = [];
      this.action = null;
      this.components = [];
      this.component = null;
      this.component_indexes = [];
      this.threshold = null;
      this.configurations = [];
    },
    closeDeleteForm() {
      this.display_table = true;
      this.display_delete_form = false;
    },
    setNewSchedule() {
      if (this.vessel != null
          && this.action != null
          && this.component != null
          && this.threshold != null) {

        if (this.action in this.actions && this.action != 'all') {
          return false;
        }

        if (this.component in this.components && this.component != 'all') {
          return false;
        }

        if (isNaN(this.threshold)) {
          return false;
        }

        this.threshold = parseInt(this.threshold);

        let scheduleData = {
          "vessel": this.vessel,
          "component_type": this.component,
          "action": this.action,
          "threshold": this.threshold
        }

        axios.post(`${store.config.api_location}/maintenance/tasks/schedule/create`, scheduleData, {headers: {Authorization: store.userProfile.jwt}})
            .then((res) => {
              this.getTasksSchedule();
            });
      }
    },
    getTasksSchedule() {
      this.loading = true;
      this.schedule = [];

      axios.get(`${store.config.api_location}/maintenance/tasks/schedule`, {headers: {Authorization: store.userProfile.jwt}})
          .then((res) => {
            this.loading = false;

            this.display_table = true;
            this.display_delete_form = false;

            this.schedule = res.data.data.schedule;

            this.closeNewScheduleForm();
          })
          .catch(() => {
            this.loading = false;
          });
    },
    getVesselConfiguration() {
      this.loading = true;

      this.actions = [];
      this.action = null;
      this.components = [];
      this.component = null;
      this.component_indexes = [];
      this.threshold = null;
      this.configurations = [];

      axios.get(`${store.config.api_location}/maintenance/tasks/configuration/${this.vessel}`, {headers: {Authorization: store.userProfile.jwt}})
          .then((res) => {
            this.loading = false;

            this.configurations = res.data.data.configurations;

            let action = this.configurations.map((item) => {
              return item.action
            });

            this.actions = ['all', ...[...new Set(action)].sort()];
          })
          .catch(() => {
            this.loading = false;
          });
    },
    scheduleSelected(e) {
      this.selectedScheduleRow = e.currentSelectedRowKeys[0];

      this.display_delete_form = true;
      this.display_table = false
    },
    deleteSchedule() {
      axios.get(`${store.config.api_location}/maintenance/tasks/schedule/delete/${this.selectedScheduleRow['id']}`, {headers: {Authorization: store.userProfile.jwt}})
          .then((res) => {
            this.getTasksSchedule();
          })
          .catch(() => {
            this.loading = false;
          });
    }
  },
  computed: {},
  watch: {
    vessel: function (value) {
      if (value != null) {
        this.getVesselConfiguration();
      }
    },
    action: function () {
      this.components = [];
      this.component = null;
      this.component_indexes = [];
      this.threshold = null;

      if (this.action != null) {
        let components = this.configurations.filter((item) => {
          return item.action == this.action
        }).map((item) => {
          return item.component
        });

        this.components = ['all', ...[...new Set(components)].sort()];

        if (this.action == 'all') {
          this.component = 'all';
        }
      } else {
        this.components = [];
      }
    },
    component: function () {
      this.component_indexes = [];
      this.threshold = null;

      if (this.action != null && this.component != null) {
        if (this.component != 'all') {
          let components = this.configurations.filter((item) => {
            return item.action == this.action
          }).filter((item) => {
            return item.component == this.component
          })[0].index;

          this.component_indexes = ['all', ...[...new Set(components)].sort()];
        } else {
          this.component_indexes = ['all'];
        }
      } else {
        this.component_indexes = [];
      }
    }
  }
}
</script>

<style scoped>

</style>